import classNames from "classnames";
import React from "react";

export const RequestSMSCode = ({btnText, btnCss, onRequestTokenClick, remainingTime, getRemainingTimeText}) => {

    return <>
        {/* Request MFA Code Button */}
        <div className="col-md-12 col-12 font-19">
            <a className={classNames(
                btnCss,
                {
                    'disabled': remainingTime > 0
                }
            )}
                onClick={onRequestTokenClick} disabled={remainingTime > 0}>
                {btnText}
            </a>
            {remainingTime > 0 && (
                <div className="pt-2">
                    Send verification code is disabled for {getRemainingTimeText()} sec. Please wait
                </div>
            )}
        </div>
    </>
}